<template>
  <BasePageContainer>
    <SettingHeader>
      テンプレート追加
    </SettingHeader>
    <div class="pt-10 pb-4">
      <MandalaGoalTemplateForm
        v-if="initialized"
        :mandala-goal-template="mandalaGoalTemplate"
        :response-errors="responseErrors"
        @submit="submit" />
    </div>
  </BasePageContainer>
</template>

<script>
import SettingHeader from '@/components/parts/SettingHeader.vue'
import MandalaGoalTemplateForm from '@/components/view/mandala_goal_templates/MandalaGoalTemplateForm.vue'

export default {
  components: {
    SettingHeader,
    MandalaGoalTemplateForm
  },
  data() {
    return {
      mandalaGoalTemplate: null,
      responseErrors: {},
      initialized: false
    }
  },
  computed: {
    copyWithTemplateId() {
      return this.$route.query.copyWith
    }
  },
  async created() {
    this.$store.commit('startLoading')
    if (this.copyWithTemplateId) {
      await this.fetchMandalaGoalTemplate()
    }
    this.initialized = true
    this.$store.commit('finishLoading')
  },
  methods: {
    async submit(body) {
      this.$store.commit('startLoading')

      await this.$axios.post('/mandala_goal_templates/', body).then((res) => {
        const newMandalaGoalTemplate = res.data
        this.$store.commit('notify/set', {message: `${newMandalaGoalTemplate.name}を作成しました`})
        this.$router.push('/admin/mandala_goal_templates/')
      }).catch((e) => {
        console.error(e)
        this.responseErrors = e.response.data
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })

      this.$store.commit('finishLoading')
    },
    fetchMandalaGoalTemplate() {
      return this.$axios.get(`/mandala_goal_templates/${this.copyWithTemplateId}/`).then(res => {
        this.mandalaGoalTemplate = res.data
      })
    },
  },
}
</script>

<style>

</style>